import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

const reducer = (state = INITIAL_STATE, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case '@plans/ADMIN_CREATE_SUBSCRIPTION_REQUEST': {
        draft.loading = true;

        break;
      }

      case '@plans/ADMIN_CREATE_SUBSCRIPTION_SUCCESS': {
        draft.loading = false;

        break;
      }

      case '@plans/ADMIN_UPDATE_SUBSCRIPTION_REQUEST': {
        draft.loading = true;

        break;
      }

      case '@plans/ADMIN_UPDATE_SUBSCRIPTION_SUCCESS': {
        draft.loading = false;

        break;
      }

      case '@plans/failure': {
        draft.loading = false;

        break;
      }

      default:
    }
  });

export default reducer;
